import React, { type ComponentType } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint, LazySuspense } from 'react-loosely-lazy';

import type { FormFieldComponentRendererProps } from '../../../../../../../../common/types/renderers';

const LazyEditParagraphRichTextInput = lazyForPaint<ComponentType<FormFieldComponentRendererProps>>(
	() => import('./main').then(({ EditParagraphRichTextInput }) => EditParagraphRichTextInput),
	{ ssr: false },
);

export const AsyncEditParagraphRichTextInput = (
	props: FormFieldComponentRendererProps,
): React.JSX.Element => (
	<LazySuspense fallback={null}>
		<LazyEditParagraphRichTextInput {...props} />
	</LazySuspense>
);
